// extracted by mini-css-extract-plugin
export default {"authContainer":"View_authContainer__khthj","main":"View_main__nav+p"};